import React, { useState, useEffect } from "react";
import Aside from "../common/Asside";
import Header from "../common/Header";

function Home() {
  // State to track the visibility of each section
  const [visibleSections, setVisibleSections] = useState({
    registeredUsers: true,
    firstDeposit: true,
    deposit: true,
    withdrawal: true,
    bonus: true,
    vipCashBonus: true,
    referralCommission: true,
    turnover: true,
    affiliateProfitLoss: true,
  });

	const [calcData, setCalcData] = useState({ paid: 0, unpaid: 0, commission: 0});
  const [showDetailsModal, setShowDetailsModal] = useState(null); // Track which detail modal is open

  const [data, setData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const[deductionRate, setDeductionRate] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch("https://api2b.pro/api/afiiliateindexnew", {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        setData(result);

        const deductionRateStr = result?.profit_and_loss?.this_month?.deductionRate || "0.00";
        const deductionRateing = parseFloat(deductionRateStr.replace(/,/g, "") || 0);
		  setDeductionRate(deductionRateing);
			
		  	let commission = 0;
			let paid = 0;
			let unpaid = 0;

			if (result?.profit_and_loss) {
				paid = result.profit_and_loss.filter(item => item.status !== 2).reduce((acc, item) => acc + Number(item.paid || 0), 0);
				commission = result.profit_and_loss.filter(item => item.status !== 2).reduce((acc, item) => acc + Number(item.commission || 0), 0);
			}
		  
		  unpaid = commission - paid;

		  console.log("Calculated Data:", { paid, unpaid, commission });
		setCalcData({ paid, unpaid, commission });

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading after fetch completes
      }
    };

    fetchData();
  }, []);

  // Toggle function to update visibility for each section
  const toggleSection = (section) => {
    setVisibleSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  // Function to show/hide details modal
  const toggleDetailsModal = (itemId) => {
    setShowDetailsModal(showDetailsModal === itemId ? null : itemId);
  };

  // Function to calculate breakdown details
  const calculateBreakdown = (item) => {
    const extra = item.extra || {};
    const deposit = parseFloat(extra.deposit || 0);
    const withdraw = parseFloat(extra.withdraw || 0);
    const bonus = parseFloat(extra.bonus || 0);
    const adjustment = parseFloat(extra.adjustment || 0);
    const payerBalance = parseFloat(extra.payer_balance || 0);
    const openBets = parseFloat(extra.open_bets || 0);
    const commissionRate = parseFloat(extra.commission_rate || 0);
    const adminRate = parseFloat(extra.extra_deduction_percent || 0);

    const allDeductions = withdraw + bonus + adjustment + payerBalance + openBets;
    const loss = deposit - allDeductions;
    const mainCommission = loss * (commissionRate + adminRate);
	  const companyDeduction = loss * adminRate;
	  const finalCommission = mainCommission - companyDeduction;

    return {
      deposit,
      withdraw,
      bonus,
      adjustment,
      payerBalance,
      openBets,
      allDeductions,
      loss,
      commissionRate,
	  mainCommission,
	adminRate,
		companyDeduction,
	  finalCommission
    };
  };

  

  return (
    <div>
       <div>
      {loading ? (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
          <div
            className="blockUI blockMsg blockElement"
            style={{
              zIndex: 10010,
              position: 'absolute',
              padding: '15px',
              margin: '0px',
              width: '30%',
              textAlign: 'center',
              color: 'rgb(255, 255, 255)',
              border: 'none',
              backgroundColor: 'rgb(0, 0, 0)',
              cursor: 'default',
              borderRadius: '10px',
              opacity: '0.493912'
            }}
          >
            Loading...
          </div>
          <div className="modal-backdrop fade active"></div>
        </div>
      ) : (
        <div>
         
        </div>
      )}
    </div>
     
   
   
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
              <div className="page-content-body" style={{ display: "block" }}>
              <div className="col-wrap panel-group">
                  {/* Commission Section */}
                  <div className="section col-2 panel">
                    <div className="section-body">
                      <h4>Commission { (data?.actual_affiliate?.cycle ? `(${data?.actual_affiliate?.cycle} Day Cycle)` : '') }</h4>
					<div className="float-right">
						<div className="form-group">
                          <h4>Active Period<br/>
                            Running 
                          </h4>
                          <p className="number" id="thisPeriodCommission">
                            { data?.actual_affiliate?.active?.commission ?? 0 }
                          </p>
                        </div>
                        <div className="form-group">
                          <h4>This Period<br/>
                            { (data?.actual_affiliate?.items[0]) ? data?.actual_affiliate?.items[0].start_date +" - "+ data?.actual_affiliate?.items[0].end_date : ''} 
                          </h4>
                          <p className="number" id="thisPeriodCommission">
                            { data?.actual_affiliate?.items[0]?.commission ?? 0 }
                          </p>
                        </div>
                        <div className="form-group">
                          <h4>Last Period<br/>
                            { (data?.actual_affiliate?.items[1]) ? data?.actual_affiliate?.items[1].start_date +" - "+ data?.actual_affiliate?.items[1].end_date : ''} 
                          </h4>
                          <p className="number" id="lastPeriodCommission">
                          { data?.actual_affiliate?.items[1]?.commission ?? 0 }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Active Players Section */}
                  <div className="section col-2 panel">
                    <div className="section-body">
                      <h4>Active Players</h4>
                      <div className="float-right">
                        <div className="form-group">
                          <h4>This Period</h4>
                          <p className="number" id="thisPeriodActivePlayer">
                            {data?.actual_affiliate?.active?.active_players || 0}
                          </p>
                        </div>
                        <div className="form-group">
                          <h4>Last Period</h4>
                          <p className="number" id="lastPeriodActivePlayer">
                          {data?.actual_affiliate?.items[0]?.active_players || 0}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-wrap">
                  <div className="section col-2 panel" id="section_5">
                    <div className="section-head">
                      <h2 className="title">Registered Users</h2>
                      <button
                        className="btn-ic-grey dropdown-toggle"
                        onClick={() => toggleSection("registeredUsers")}
                      />
                    </div>
                    <div className={`section-body ${visibleSections.registeredUsers ? "d-block" : "d-none"}`}>
                      <table className="table table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>Period</th>
                            <th>Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="align-center">Today</td>
                            <td>{data?.registered_users?.today || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Yesterday</td>
                            <td>{data?.registered_users?.yesterday || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Week</td>
                            <td>{data?.registered_users?.this_week || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Week</td>
                            <td>{data?.registered_users?.last_week || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Month</td>
                            <td>{data?.registered_users?.this_month || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Month</td>
                            <td>{data?.registered_users?.last_month || 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* Repeat similar structure for other sections */}
                  {/* First Deposit Section */}
                  <div className="section col-2 panel" id="section_4">
                    <div className="section-head">
                      <h2 className="title">First Deposit</h2>
                      <button
                        className="btn-ic-grey dropdown-toggle"
                        onClick={() => toggleSection("firstDeposit")}
                      />
                    </div>
                    <div className={`section-body ${visibleSections.firstDeposit ? "d-block" : "d-none"}`}>
                      <table className="table table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>Period</th>
                            <th>Count</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="align-center">Today</td>
                            <td>{data?.first_deposit?.today?.count || 0}</td>
                            <td>{data?.first_deposit?.today?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Yesterday</td>
                            <td>{data?.first_deposit?.yesterday?.count || 0}</td>
                            <td>{data?.first_deposit?.yesterday?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Week</td>
                            <td>{data?.first_deposit?.this_week?.count || 0}</td>
                            <td>{data?.first_deposit?.this_week?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Week</td>
                            <td>{data?.first_deposit?.last_week?.count || 0}</td>
                            <td>{data?.first_deposit?.last_week?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Month</td>
                            <td>{data?.first_deposit?.this_month?.count || 0}</td>
                            <td>{data?.first_deposit?.this_month?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Month</td>
                            <td>{data?.first_deposit?.last_month?.count || 0}</td>
                            <td>{data?.first_deposit?.last_month?.sum || "0.00"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                </div>
                <div className="col-wrap"> 
                  {/* Deposit Section */}
                <div className="section col-2 panel" id="section_2">
                  <div className="section-head">
                    <h2 className="title">Deposit</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("deposit")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.deposit ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.deposits?.today?.count || 0}</td>
                          <td>{data?.deposits?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.deposits?.yesterday?.count || 0}</td>
                          <td>{data?.deposits?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.deposits?.this_week?.count || 0}</td>
                          <td>{data?.deposits?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.deposits?.last_week?.count || 0}</td>
                          <td>{data?.deposits?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.deposits?.this_month?.count || 0}</td>
                          <td>{data?.deposits?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.deposits?.last_month?.count || 0}</td>
                          <td>{data?.deposits?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Withdrawal Section */}
                <div className="section col-2 panel" id="section_3">
                  <div className="section-head">
                    <h2 className="title">Withdrawal</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("withdrawal")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.withdrawal ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.withdraws?.today?.count || 0}</td>
                          <td>{data?.withdraws?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.withdraws?.yesterday?.count || 0}</td>
                          <td>{data?.withdraws?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.withdraws?.this_week?.count || 0}</td>
                          <td>{data?.withdraws?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.withdraws?.last_week?.count || 0}</td>
                          <td>{data?.withdraws?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.withdraws?.this_month?.count || 0}</td>
                          <td>{data?.withdraws?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.withdraws?.last_month?.count || 0}</td>
                          <td>{data?.withdraws?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                </div>
                <div className="col-wrap">
                  {/* Bonus Section */}
                <div className="section col-2 panel" id="section_0">
                  <div className="section-head">
                    <h2 className="title">Bonus</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("bonus")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.bonus ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.bonuses?.today?.count || 0}</td>
                          <td>{data?.bonuses?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.bonuses?.yesterday?.count || 0}</td>
                          <td>{data?.bonuses?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.bonuses?.this_week?.count || 0}</td>
                          <td>{data?.bonuses?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.bonuses?.last_week?.count || 0}</td>
                          <td>{data?.bonuses?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.bonuses?.this_month?.count || 0}</td>
                          <td>{data?.bonuses?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.bonuses?.last_month?.count || 0}</td>
                          <td>{data?.bonuses?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* VIP Cash Bonus Section */}
                <div className="section col-2 panel" id="section_13">
                  <div className="section-head">
                    <h2 className="title">VIP Cash Bonus</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("vipCashBonus")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.vipCashBonus ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.vipbonuses?.today?.count || 0}</td>
                          <td>{data?.vipbonuses?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.vipbonuses?.yesterday?.count || 0}</td>
                          <td>{data?.vipbonuses?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.vipbonuses?.this_week?.count || 0}</td>
                          <td>{data?.vipbonuses?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.vipbonuses?.last_week?.count || 0}</td>
                          <td>{data?.vipbonuses?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.vipbonuses?.this_month?.count || 0}</td>
                          <td>{data?.vipbonuses?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.vipbonuses?.last_month?.count || 0}</td>
                          <td>{data?.vipbonuses?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
                <div className="col-wrap">
                  {/* Referral Commission Section */}
                <div className="section col-2 panel" id="section_15">
                  <div className="section-head">
                    <h2 className="title">Referral Commission</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("referralCommission")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.referralCommission ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.refcommissions?.today?.count || 0}</td>
                          <td>{data?.refcommissions?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.refcommissions?.yesterday?.count || 0}</td>
                          <td>{data?.refcommissions?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.refcommissions?.this_week?.count || 0}</td>
                          <td>{data?.refcommissions?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.refcommissions?.last_week?.count || 0}</td>
                          <td>{data?.refcommissions?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.refcommissions?.this_month?.count || 0}</td>
                          <td>{data?.refcommissions?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.refcommissions?.last_month?.count || 0}</td>
                          <td>{data?.refcommissions?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Turnover Section */}
                <div className="section col-2 panel" id="section_6">
                  <div className="section-head">
                    <h2 className="title">Turnover</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("turnover")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.turnover ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.turnovers?.today?.count || 0}</td>
                          <td>{data?.turnovers?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.turnovers?.yesterday?.count || 0}</td>
                          <td>{data?.turnovers?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.turnovers?.this_week?.count || 0}</td>
                          <td>{data?.turnovers?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.turnovers?.last_week?.count || 0}</td>
                          <td>{data?.turnovers?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.turnovers?.this_month?.count || 0}</td>
                          <td>{data?.turnovers?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.turnovers?.last_month?.count || 0}</td>
                          <td>{data?.turnovers?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                </div>
                <div className="col-wrap">
					{/* Affiliate Profit & Loss Section */}
					<div className="section col-1 panel" id="section_1">
						<div className="section-head">
							<h2 className="title">Affiliate Profit & Loss</h2>
							<button
								className="btn-ic-grey dropdown-toggle"
								onClick={() => toggleSection("affiliateProfitLoss")}
							/>
						</div>
						<div className={`section-body ${visibleSections.affiliateProfitLoss ? "d-block" : "d-none"}`}>
							<table className="table table-striped">
								<thead className="thead-light">
									<tr>
										<th className="align-left">Period</th>
										<th>Active Player</th>
										<th>Amount</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									{data?.profit_and_loss.map((item, index) => {
										const breakdown = calculateBreakdown(item);
										return (
											<React.Fragment key={index}>
												<tr>
													<td className="align-left">
														{item.start_date ?? 'No Date Recored'}
														{item.end_date ? ` - ${item.end_date}` : ''}
														{item.status === 2 ? <span className="x-badge badge-success">Current Cycle</span> : ''}
														{item.status === 1 && item.paid > 0 ? <span className="x-badge badge-success">Paid</span> : ''}
													</td>
													<td>{item.active_players || 0}</td>
													<td className={(item.status === 1 ? item.paid : item.commission) < 0 ? "text-danger" : ""}>
														{(item.status === 1
															? (item.paid ?? 0)
															: (item.commission ?? 0)
														).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
													</td>
													<td>
														<button 
															className="btn btn-sm btn-info"
															onClick={() => toggleDetailsModal(item.id)}
															style={{ fontSize: '12px', padding: '4px 8px' }}
														>
															{showDetailsModal === item.id ? 'Hide Details' : 'Show Details'}
														</button>
													</td>
												</tr>
												{showDetailsModal === item.id && (
													<tr>
														<td colSpan="4" style={{ backgroundColor: '#f8f9fa', padding: '15px' }}>
															<div style={{ border: '1px solid #dee2e6', borderRadius: '5px', padding: '15px', backgroundColor: 'white' }}>
																<h6 style={{ marginBottom: '15px', color: '#495057' }}>Commission Calculation Breakdown - Period: {item.start_date} to {item.end_date}</h6>
																
																<div style={{ fontFamily: 'monospace', fontSize: '14px', lineHeight: '1.6' }}>
																	<div style={{ marginBottom: '15px' }}>
																		<strong>Step 1: Total Deductions</strong><br/>
																		<div style={{ marginTop: '8px', paddingLeft: '10px' }}>
																			<div>Withdrawals = {breakdown.withdraw.toLocaleString()}</div>
																			<div>Bonuses = {breakdown.bonus.toLocaleString()}</div>
																			<div>Adjustments = {breakdown.adjustment.toLocaleString()}</div>
																			<div>Payer Balance = {breakdown.payerBalance.toLocaleString()}</div>
																			<div>Open Bets = {breakdown.openBets.toLocaleString()}</div>
																			<div style={{ borderTop: '1px solid #dee2e6', marginTop: '8px', paddingTop: '8px', fontWeight: 'bold' }}>
																				Total = {breakdown.allDeductions.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
																			</div>
																		</div>
																	</div>
																	
																	<div style={{ marginBottom: '15px' }}>
																		<strong>Step 2: Net Loss/Profit</strong><br/>
																		<div style={{ marginTop: '8px', paddingLeft: '10px' }}>
																			<div>Deposits = {breakdown.deposit.toLocaleString()}</div>
																			<div>Total Deductions = {breakdown.allDeductions.toLocaleString()}</div>
																			<div style={{ borderTop: '1px solid #dee2e6', marginTop: '8px', paddingTop: '8px', fontWeight: 'bold', color: breakdown.loss >= 0 ? '#28a745' : '#dc3545' }}>
																				Net Result = {breakdown.loss.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
																			</div>
																		</div>
																	</div>
																	
																	<div style={{ marginBottom: '15px' }}>
																		<strong>Step 3: Total Commission ({((breakdown.commissionRate + breakdown.adminRate) * 100).toFixed(2)}%)</strong><br/>
																		<div style={{ marginTop: '8px', paddingLeft: '10px' }}>
																			<div>Net Result = {breakdown.loss.toLocaleString()}</div>
																			<div>Commission Rate = {((breakdown.commissionRate + breakdown.adminRate) * 100).toFixed(2)}%</div>
																			<div style={{ borderTop: '1px solid #dee2e6', marginTop: '8px', paddingTop: '8px', fontWeight: 'bold', color: breakdown.mainCommission >= 0 ? '#28a745' : '#dc3545' }}>
																				Total Commission = {breakdown.mainCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
																			</div>
																		</div>
																	</div>
																	
																	<div style={{ marginBottom: '15px' }}>
																		<strong>Step 4: Company Deduction</strong><br/>
																		<div style={{ marginTop: '8px', paddingLeft: '10px' }}>
																			<div>Net Result = {breakdown.loss.toLocaleString()}</div>
																			<div style={{ borderTop: '1px solid #dee2e6', marginTop: '8px', paddingTop: '8px', fontWeight: 'bold' }}>
																				Company Deduction = {breakdown.companyDeduction.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
																			</div>
																		</div>
																	</div>
																	
																	<div style={{ marginBottom: '10px' }}>
																		<strong>Step 5: Final Commission</strong><br/>
																		<div style={{ marginTop: '8px', paddingLeft: '10px' }}>
																			<div>Total Commission = {breakdown.mainCommission.toLocaleString()}</div>
																			<div>Company Deduction = {breakdown.companyDeduction.toLocaleString()}</div>
																			<div style={{ borderTop: '1px solid #dee2e6', marginTop: '8px', paddingTop: '8px', fontWeight: 'bold', color: breakdown.finalCommission >= 0 ? '#28a745' : '#dc3545', fontSize: '16px' }}>
																				Final Commission = {breakdown.finalCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</td>
													</tr>
												)}
											</React.Fragment>
										);
									})}
								</tbody>
								<tfoot>
									<tr>
										<td className="align-right" colSpan="3"><strong>Total Commission</strong></td>
										<td className={calcData.commission < 0 ? "text-danger" : ""}>
											{calcData.commission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
										</td>
									</tr>
									<tr>
										<td className="align-right" colSpan="3"><strong>Total Paid</strong></td>
										<td className={calcData.paid < 0 ? "text-danger" : ""}>
											{calcData.paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
										</td>
									</tr>
									<tr>
										<td className="align-right" colSpan="3"><strong>Total Unpaid</strong></td>
										<td className={calcData.unpaid < 0 ? "text-danger" : ""}>
											{calcData.unpaid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
										</td>
									</tr>
								</tfoot>

							</table>
						</div>
					</div>
					{/* Affiliate Profit & Loss Section */}

				</div>


              </div>
            </div>
            <footer className="footer">Copyright © 2024. All rights Reserved</footer>
            <div className="modal-backdrop fade" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
